import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

export const getRecipes = async () => {
  try {
    const recipesRef = collection(db, "recipes");
    const snapshot = await getDocs(recipesRef);
    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Error getting recipes: ", error);
    throw error;
  }
}

export const getRecipeById = async (id) => {
  try {
    const recipeRef = doc(db, "recipes", id);
    const recipeSnapshot = await getDoc(recipeRef);

    if (recipeSnapshot.exists()) {
      return {
        id: recipeSnapshot.id,
        ...recipeSnapshot.data(),
      };
    } else {
      throw new Error("Recipe not found");
    }
  } catch (error) {
      console.error("Error fetching recipe:", error);
    throw error;
  }
}

export const getImageUrl = async (imagePath) => {
  console.log("getting image: SERVER")
  return new Promise((resolve) => {
    const publicUrl = `${imagePath}`;
    setTimeout(() => resolve(publicUrl), 500);
  })
}

export const addRecipe = async (recipe) => {
  try {
    console.log(recipe)
    const recipesRef = collection(db, "recipes");
    const docRef = await addDoc(recipesRef, recipe);
    return { id: docRef.id, ...recipe };
  } catch (error) {
    console.error('Error adding recipe: ', error);
    throw error;
  }
}

export const saveRecipe = async (updatedRecipe) => {
  try {
    const recipeRef = doc(db, "recipes", updatedRecipe.id);
    await updateDoc(recipeRef, updatedRecipe);
  } catch (error) {
    console.error("Error updateing recipe: ", error);
    throw error;
  }
}

const getUserSaveRef = (userId, recipeId) =>
  doc(db, "users", userId, "saves", recipeId);

const getUserSavesCollection = (userId) =>
  collection(db, "users", userId, "saves");

export const saveRecipeForUser = async (recipeId, userId) => {
  try {
    const saveRef = getUserSaveRef(userId, recipeId);
    await setDoc(saveRef, {
      recipeId,
      savedAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error saving recipe for user: ", error);
    throw error;
  }
};

export const removeSavedRecipeForUser = async (recipeId, userId) => {
  try {
    const saveRef = getUserSaveRef(userId, recipeId);
    await deleteDoc(saveRef);
  } catch (error) {
    console.error("Error removing saved recipe for user: ", error);
    throw error;
  }
};

export const getSavedRecipeIdsForUser = async (userId) => {
  try {
    const savesSnapshot = await getDocs(getUserSavesCollection(userId));
    return savesSnapshot.docs.map((docSnapshot) => docSnapshot.id);
  } catch (error) {
    console.error("Error fetching saved recipes for user:", error);
    throw error;
  }
};

export const isRecipeSavedForUser = async (recipeId, userId) => {
  try {
    const saveSnapshot = await getDoc(getUserSaveRef(userId, recipeId));
    return saveSnapshot.exists();
  } catch (error) {
    console.error("Error checking saved recipe for user:", error);
    throw error;
  }
};

export const deleteRecipe = async (recipeId) => {
  try {
    const recipeRef = doc(db, "recipes", recipeId);
    await deleteDoc(recipeRef);
    console.log(`Recipe with ID ${recipeId} deleted sucessfully`);
  } catch (error) {
    console.error("Error deleting recipe: ", error);
    throw error;
  }
}

export const uploadImage = async (file) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const imagePath = URL.createObjectURL(file);

      resolve(imagePath);
    }, 500)
  })
}